// src/services/shift.service.js
import { api } from './api';


class ShiftService {
    constructor() {
        this.api = api;

        // Add auth token to requests
        this.api.interceptors.request.use((config) => {
            const token = localStorage.getItem('authToken');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        });
    }

    // Get all shifts
    async getAllShifts() {
        try {
            const response = await this.api.get('/api/shifts');
            console.log("Raw shifts response:", response);
            const shifts = response.data?.shifts || response.data || response || [];
            console.log("Processed shifts:", shifts);
            return Array.isArray(shifts) ? shifts : [];
        } catch (error) {
            console.error('Error fetching shifts:', error);
            throw error.response?.data || error;
        }
    }

    // Get shift by ID
    async getShiftById(shiftId) {
        try {
            const response = await this.api.get(`/api/shifts/${shiftId}`);
            console.log("Raw shifts response:", response);
            const shifts = response.data?.shifts || response.data || response || [];
            console.log("Processed shifts:", shifts);
            return Array.isArray(shifts) ? shifts : [];
        } catch (error) {
            console.error('Error fetching shift:', error);
            throw error.response?.data || error;
        }
    }

    // Create new shift
    async createShift(shiftData) {
        try {
            const response = await this.api.post('/api/shifts', shiftData);
            console.log("Raw shifts response:", response);
            const shifts = response.data?.shifts || response.data || response || [];
            console.log("Processed shifts:", shifts);
            return Array.isArray(shifts) ? shifts : [];
        } catch (error) {
            console.error('Error creating shift:', error);
            throw error.response?.data || error;
        }
    }

    // Update shift
    async updateShift(shiftId, shiftData) {
        try {
            const response = await this.api.put(`/api/shifts/${shiftId}`, shiftData);
            console.log("Raw shifts response:", response);
            const shifts = response.data?.shifts || response.data || response || [];
            console.log("Processed shifts:", shifts);
            return Array.isArray(shifts) ? shifts : [];
        } catch (error) {
            console.error('Error updating shift:', error);
            throw error.response?.data || error;
        }
    }

    // Delete shift
    async deleteShift(shiftId) {
        try {
            const response = await this.api.delete(`/api/shifts/${shiftId}`);
            console.log("Raw shifts response:", response);
            const shifts = response.data?.shifts || response.data || response || [];
            console.log("Processed shifts:", shifts);
            return Array.isArray(shifts) ? shifts : [];
        } catch (error) {
            console.error('Error deleting shift:', error);
            throw error.response?.data || error;
        }
    }

    // Get employees assigned to a shift
    async getShiftEmployees(shiftId) {
        try {
            const response = await this.api.get(`/api/shifts/${shiftId}/employees`);
            console.log("Raw shift employees response:", response);
            // Backend returns { success: true, employees: [...] }
            const employees = response.data?.employees || response.data || [];
            console.log("Processed employees:", employees);
            return { success: true, employees: Array.isArray(employees) ? employees : [] };
        } catch (error) {
            console.error('Error fetching shift employees:', error);
            return { success: false, employees: [] };
        }
    }

    // Assign employees to shift
    async assignEmployeesToShift(shiftId, employeeIds) {
        try {
            const response = await this.api.post(`/api/shifts/${shiftId}/assign`, { employeeIds });
            console.log("Raw shifts response:", response);
            const shifts = response.data?.shifts || response.data || response || [];
            console.log("Processed shifts:", shifts);
            return Array.isArray(shifts) ? shifts : [];
        } catch (error) {
            console.error('Error assigning employees to shift:', error);
            throw error.response?.data || error;
        }
    }

    // Remove employees from shift
    async removeEmployeesFromShift(shiftId, employeeIds) {
        try {
            const response = await this.api.delete(`/api/shifts/${shiftId}/remove`, { data: { employeeIds } });
            console.log("Raw shifts response:", response);
            const shifts = response.data?.shifts || response.data || response || [];
            console.log("Processed shifts:", shifts);
            return Array.isArray(shifts) ? shifts : [];
        } catch (error) {
            console.error('Error removing employees from shift:', error);
            throw error.response?.data || error;
        }
    }
}

export default new ShiftService();